export default {
  orders: {},
  products: {},
  blogs: {},
}
